import { withRouter } from '../utils'
import { Link } from 'react-router-dom'
import '../styles/privacy.css'

function Privacy(){
    return (
    <>

        <main className="main sm">
            <div className="main__bg">
                <img src="icons/bg-4.webp" alt="bg" />
            </div>

            <section class="privacy-section">
                <h1>Privacy Policy</h1><br/>

                <h3>1. Introduction</h3><br/>

                <p style={{fontWeight: 'bold'}}>FORTE (“we”, “our”, or “us”) is committed to protecting and respecting your privacy. This Privacy Policy explains how we collect, use, process, and protect personal information when you interact with our website, services, and emergency evacuation coordination systems.</p><br/>
                <p style={{fontWeight: 'bold'}}>By using our services or submitting information through our website, you agree to the terms outlined in this Privacy Policy.</p><br/>

                <h3>2. Information We Collect</h3><br/>

                <p style={{fontWeight: 'bold'}}>We may collect and process the following types of information:</p><br/>

                <p>Personal Identification Information</p>
                <ul class="policy-list">
                    <li>Full name</li>
                    <li>Email address</li>
                    <li>Phone number</li>
                    <li>Nationality</li>
                    <li>Passport information (when required for evacuation coordination)</li>
                </ul>
                <br/>

                <p>Operational Information</p>
                <ul class="policy-list">
                    <li>Current location or travel details</li>
                    <li>Number of individuals requiring evacuation</li>
                    <li>Emergency contact information</li>
                    <li>Special medical or logistical requirements</li>
                </ul>
                <br/>

                <p>Technical Information</p>
                <ul class="policy-list">
                    <li>IP address</li>
                    <li>Browser type and device information</li>
                    <li>Website usage data collected through cookies or analytics tools</li>
                </ul>
                <br/>

                <h3>3. How We Use Your Information</h3><br/>

                <p>We collect and process information for the following purposes:</p>
                <ul class="policy-list">
                    <li>To assess security risks and evacuation needs</li>
                    <li>To coordinate emergency transportation and logistics</li>
                    <li>To communicate operational updates and instructions</li>
                    <li>To verify identity and travel documentation</li>
                    <li>To respond to inquiries or service requests</li>
                    <li>To improve our services and website performance</li>
                    <li>To comply with legal or regulatory requirements</li>
                </ul>
                <br/>
                <p>Your information will only be used for purposes directly related to operational support, risk assessment, or service delivery.</p><br/>

                <h3>4. Information Sharing</h3><br/>

                <p style={{fontWeight: 'bold'}}>We do not sell or rent personal information.</p><br/>
                <p>Information may be shared only when necessary with trusted partners involved in the evacuation or security operation, including:</p>

                <ul class="policy-list">
                    <li>Transportation providers</li>
                    <li>Security partners</li>
                    <li>Aviation operators</li>
                    <li>Immigration or government authorities when legally required</li>
                    <li>Technology providers supporting operational systems</li>
                </ul>
                <br/>
                <p>All partners are required to maintain strict confidentiality and data protection standards.</p><br/>

                <h3>5. Data Security</h3><br/>

                <p style={{fontWeight: 'bold'}}>We implement appropriate technical and organizational security measures to protect personal data from unauthorized access, alteration, disclosure, or destruction.</p><br/>
                <p>These measures may include:</p>

                <ul class="policy-list">
                    <li>Secure data transmission</li>
                    <li>Restricted access to operational data</li>
                    <li>Encrypted storage systems</li>
                    <li>Internal confidentiality protocols</li>
                </ul>
                <br/>
                <p>However, no method of data transmission over the internet can be guaranteed to be completely secure.</p><br/>

                <h3>6. Data Retention</h3><br/>

                <p style={{fontWeight: 'bold'}}>Personal data will be retained only for as long as necessary to fulfill the purposes for which it was collected, including operational coordination, legal compliance, and internal record keeping.</p><br/>
                <p style={{fontWeight: 'bold'}}>Once the data is no longer required, it will be securely deleted or anonymized.</p><br/>

                <h3>7. Your Rights</h3><br/>
                <p>Depending on applicable regulations, you may have the right to:</p><br/>

                <ul class="policy-list">
                    <li>Request access to your personal data</li>
                    <li>Request correction of inaccurate information</li>
                    <li>Request deletion of your personal data</li>
                    <li>Restrict or object to certain processing activities</li>
                </ul>
                <br/>

                <p>Requests can be submitted through the contact information below.</p><br/>

                <h3>8. Cookies and Website Analytics</h3><br/>
                <p style={{fontWeight: 'bold'}}>Our website may use cookies or similar technologies to improve user experience and analyze website traffic.</p>
                <p style={{fontWeight: 'bold'}}>You may disable cookies through your browser settings, although this may affect certain website functionality.</p><br/>

                <h3>9. Changes to This Policy</h3><br/>
                <p style={{fontWeight: 'bold'}}>We may update this Privacy Policy periodically to reflect changes in our services or legal requirements. Updated versions will be published on our website.</p><br></br>

                <h3>10. Contact</h3><br/>
                <p>For questions regarding this Privacy Policy or the handling of your personal information, please contact:</p><br/>
                <p style={{fontWeight: 'bold'}}>FORTE</p>
                <p style={{fontWeight: 'bold'}}>Email: contact@forteintel.com</p>
                <p style={{fontWeight: 'bold'}}>Website: forteintel.com</p>
                <br/>

            </section>

            <footer className="footer sm">
            <div className="auto__container">
                <div className="footer__inner">
                <div className="footer__inner-copy">
                    <div className="footer__inner-side">
                        <div className="footer__inner-logo">
                            <img src="icons/logo.webp" alt="logo" />
                        </div>
                        <p>FORTE INTEL | 2026</p>
                    </div>
                    <div className="footer__inner-links">
                        <a href="#mission">MISSION</a>
                        <a href="#services">SERVICES</a>
                        <a href="#coverage">COVERAGE</a>
                        <a href="#partners">PARTNERS</a>
                        <a href="#contact">CONTACTS</a>
                        <Link to="/privacy" className="footer__inner-log">PRIVACY</Link>
                    </div>
                    <a href="/login" className="footer__inner-log">LOGIN</a>
                </div>
                </div>
            </div>
            </footer>
      </main>
    </>
  )
}

export default withRouter(Privacy)